<template>
    <Modal 
      :id="'cmp-label-status-activate'" 
      @cancelled="onCancel"
    >
      <template slot="header"> {{ mode=='deactivate'? $t('deactive'):$t('active')}} {{ name }} </template>
      <template slot="body">
        <div>
          
          <TextField
            type="date"
            id="termination_date"
            class="m1"
            :placeholder="$t('Termination Date')"
            :value="termination_date"
            :showImmediate="false"
            autocomplete="off"
            style="max-width: 250px;min-width: 250px;" 
            @valuechanged="onTextFieldValueChange"
            v-if="mode=='deactivate'"
          />
          
          <button
            class="dt-button v1 btn-width"
            @click.stop="onBtnClick('product_only')"
          >
            {{ $dft.capHead($t('Change Product Only'))}}
          </button>
          <button 
            class="dt-button s6 btn-width"
            style="max-width: 250px;min-width: 250px;" 
            @click.stop="onCancel"
          >Cancel
          </button>
        </div>
      </template>
      <template slot="options">
     
        <!-- <button 
          class="dt-button s6" 
          @click.stop="onCancel"
        >Cancel</button> -->
           <!-- <button
          class="dt-button v1 with-ico"
           :class="{ disabled: !isFormValid }"
          :disabled="!isFormValid"
          @click.stop="addNewLicenceAccount"
        >
          {{$t('ok')}}
        </button> -->
      </template>
    </Modal>
  </template>
  
  <script>
  
  import Modal from '@dtplugins/modal/modal';

  
  import {
    createTV,
    tv,
  } from "../../../../models/text-value.model";
import { DeactivateService } from '../../services/deactivate.service';
  export default {
    components: {
      Modal,
    },
    props: {
      
    },
    data: function() {
      return {
        termination_date:''
      };
    },
    mounted:async function() {
      console.log("TTTTTTTTT",this.$route)
    },
    computed: {
      name: function () {
       return this.$route.query.name;
      },
      mode: function () {
       return this.$route.query.mode;
      },
      primary_key:function(){
        return this.$route.query.primary_key;
      },
      status_id:function(){
        return this.$route.query.status_id;
      }
    },
    methods: {

      onCancel: function() {
        this.$emit("cancelled", true);
      },
      onTextFieldValueChange:function(key, value){
        console.log("NAME",key,value)
        this[key]=value
      },
      onBtnClick:function(e){
        console.log(e)
        if(this.mode=='deactivate'){
          this.deactivate(e)
        }else{
          this.activate(e)
        }

        this.onCancel()

      },
      activate: function(e) {

          DeactivateService.changeProductStatusToActive(this.primary_key,this.status_id);

      },

      deactivate: function(e) {
        DeactivateService.changeProductStatusToDeactive(this.primary_key,this.status_id,this.termination_date);
 
      },
      //MARK: Methods
    }
  };
  
  
  </script>
  
  <style lang="scss">
  .cmp-label-status-activate {
    .dt-modal--header{
      text-align: center;
    }
    .btn-width{
      margin-left: 0px;
      max-width: 250px;
      min-width: 250px;
      padding:0px 10px;
    }
  }
  </style>